module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/HUMAN SCIENCES-ANTHROPOLOGY-8d0684a908beab3cc360c3a3c825e838.png";